import { createAction } from "@reduxjs/toolkit";
import type { UpdateDocumentaryResourceBody } from "@shared-kernel/domain/types/documentary-resource";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const documentaryResourceUpdate = createApiThunk<string, UpdateDocumentaryResourceBody>(
  "documentaryResource/update",
  async (body: UpdateDocumentaryResourceBody, { extra: { adminRepository } }) => {
    await adminRepository!.updateDocumentaryResource(body);
    return body.resourceId;
  },
);

export const documentaryResourceUpdateReset = createAction("documentaryResource/updateReset");
